import { SetConsentRequest, SetConsentResponse } from '@ketch-sdk/ketch-types'
import { formatRequestString } from '../../../../utils/helpers/api/queryString'
import { KETCH_CDN_API } from '../client/client'

export type SetConsentParams = {
  organizationCode: string
  formData: SetConsentRequest
}

export const setConsent = ({ organizationCode, formData }: SetConsentParams) =>
  KETCH_CDN_API.post<SetConsentResponse>(
    formatRequestString({
      entityUrl: `/web/v3/consent/${organizationCode}/update`,
    }),
    formData,
  )
